import { AsyncPipe, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { PillItem } from '../../../models/shared/pill-item';
import { PillComponent } from '../../pills/pill/pill.component';

@Component({
  selector: 'app-table-filter-pills',
  templateUrl: './table-filter-pills.component.html',
  styleUrls: ['./table-filter-pills.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgIf, AsyncPipe, PillComponent]
})
export class TableFilterPillsComponent {
  @Input() activeFiltersCount: number = 0;
  @Input() activeSearchCount: number = 0;
  @Input() showingSearchBar: boolean = false;
  @Input() showingFilterWindow: boolean = false;
  @Input() showFilterPill: boolean = true;
  @Output() searchPillClicked = new EventEmitter<void>();
  @Output() filterPillClicked = new EventEmitter<void>();

  public searchPill$ = new BehaviorSubject<PillItem>(
    new PillItem($localize`Search`, true, false, false, 'assets/icons/dark/Search.svg')
  );

  public filterPill$ = new BehaviorSubject<PillItem>(
    new PillItem($localize`Filters`, true, false, false, 'assets/icons/dark/Filter.svg')
  );
}
